import axios from "axios";
import { WebsiteResponse, CreateSourcePayload, MarkSourceAsNewPayload, MainEndpoints } from "@authory-packages/core";
import { API_URL, withUserSlug } from "./index";
import { getHeaders } from "./get-headers";
import { CommonArgs } from "./collections";
import { pick } from "lodash";

type createSourceType = {
    token: string;
    userSlug: string;
    source: CreateSourcePayload;
    skipInvalidateUser?: boolean;
};

export const createSource = async ({ token, userSlug, source }: createSourceType) => {
    const res = await axios.post<WebsiteResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.CreateUserSource, userSlug)}`,
        {
            ...source
        },
        getHeaders(token)
    );

    return res.data;
};

export type SourcesResponsePayload = {
    articleCounter: number;
    sources: WebsiteResponse[];
};

export const getSources = async (token: string, userId: string) => {
    const { data } = await axios.get<SourcesResponsePayload>(`${API_URL}${withUserSlug(MainEndpoints.UserSources, userId)}`, getHeaders(token));

    const rulesMap = data.sources.reduce(
        (map, obj) => {
            map[obj.canonicalSlug] = obj;
            return map;
        },
        {} as Record<string, WebsiteResponse>
    );

    return rulesMap;
};

interface updateSourceArgs extends CommonArgs {
    data: WebsiteResponse;
}

export const updateSource = async ({ token, userSlug, data }: updateSourceArgs) => {
    const updateData = pick(data, ["publicationName", "active", "visibility", "configuration", "partOfDigest", "partOfNewsletter", "notes"]);

    const res = await axios.post<WebsiteResponse>(
        `${API_URL}${withUserSlug(MainEndpoints.UpdateUserSource, userSlug).replace(":websiteId", encodeURIComponent(data.canonicalSlug))}`,
        {
            ...updateData
        },
        getHeaders(token)
    );

    return res.data;
};

interface deleteSourceArgs extends CommonArgs {
    sourceId: string;
}

export const deleteSource = async ({ token, userSlug, sourceId }: deleteSourceArgs) => {
    const { data } = await axios.post(
        `${API_URL}${withUserSlug(MainEndpoints.SoftDeleteUserSource, userSlug).replace(":websiteId", encodeURIComponent(sourceId))}`,
        {},
        getHeaders(token)
    );

    return data;
};

interface markSourceAsNewArgs {
    params: MarkSourceAsNewPayload;
    requestedUser: string;
    requestedWebsite: string;
    token: string;
}

export const markSourceAsNew = async ({ token, requestedUser, requestedWebsite, params }: markSourceAsNewArgs) => {
    const res = await axios.post(
        `${API_URL}${withUserSlug(MainEndpoints.MarkUserSourceAsNew, requestedUser).replace(":websiteId", requestedWebsite)}`,
        params,
        getHeaders(token)
    );

    return res.data;
};
